import _sfc_main from "./MoreControlH5.vue2.mjs";
/* empty css                    */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", [_setup.moreControlConfig.visible ? _c("div", { staticClass: "more-control-container" }, [_c(_setup.IconButton, { directives: [{ name: "tap", rawName: "v-tap", value: _setup.showMore, expression: "showMore" }], attrs: { "is-active": _setup.sidebarName === "more", "title": _setup.t("More"), "icon": _setup.ExtensionIcon } })], 1) : _vm._e(), _setup.showMoreContent ? _c("div", { ref: "moreContentRef", staticClass: "show-more-content" }, [_c("div", { staticClass: "control-compent" }, [_setup.roomStore.isSpeakAfterTakingSeatMode ? _c(_setup.ChatControl, { on: { "click": function($event) {
    return _setup.handleControlClick("chatControl");
  } } }) : _vm._e(), _c(_setup.ContactControl, { on: { "click": function($event) {
    return _setup.handleControlClick("contactControl");
  } } }), _c(_setup.InviteControl, { on: { "show-overlay": _setup.handleShowOverlay, "click": function($event) {
    return _setup.handleControlClick("inviteControl");
  } } })], 1), _c("div", { directives: [{ name: "tap", rawName: "v-tap", value: _setup.handleCancelControl, expression: "handleCancelControl" }], staticClass: "close" }, [_vm._v(_vm._s(_setup.t("Cancel")))])]) : _vm._e()]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "5f1fea0d"
);
const MoreControlH5 = __component__.exports;
export {
  MoreControlH5 as default
};
